import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Zap } from 'lucide-react';

function TriggerNode({ data, selected }: NodeProps) {
  const config = (data.config as Record<string, unknown>) ?? {};
  const triggerType = (config.triggerType as string) ?? 'event';
  const eventType = (config.eventType as string) ?? '';
  const schedule = (config.scheduleExpression as string) ?? '';
  const segmentId = (config.segmentId as string) ?? '';

  const summary =
    triggerType === 'schedule'
      ? schedule || 'No schedule set'
      : triggerType === 'segment_entry'
        ? segmentId || 'No segment set'
        : triggerType === 'manual'
          ? 'Manual trigger'
          : eventType || 'No event set';

  return (
    <div
      className={`w-52 rounded-xl bg-white shadow-sm border border-zinc-200 border-l-4 border-l-emerald-500 ${
        selected ? 'ring-2 ring-emerald-400' : ''
      }`}
    >
      <div className="flex items-center gap-2 px-3 py-2 border-b border-zinc-100">
        <Zap size={14} className="text-emerald-500 shrink-0" />
        <span className="text-xs font-semibold text-zinc-700 uppercase tracking-wide">Trigger</span>
      </div>
      <div className="px-3 py-2">
        <p className="text-xs text-zinc-500 capitalize">{triggerType.replace('_', ' ')}</p>
        <p className="text-xs text-zinc-800 font-medium truncate">{summary}</p>
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-emerald-500" />
    </div>
  );
}

export default memo(TriggerNode);
